export default "__VITE_ASSET__CgVq1N14__"